// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1HHgQ","signatureBlock":"Footer_signatureBlock__3xr6j","signature":"Footer_signature__1bgCm"};